import actionTypes from "../actionTypes";
import * as fakturyUtils from "../../utils/faktury/fakturyUtils";

export const updateCustomFiltersFaktury = ({ customFilters }) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_FILTERS_FAKTURY,
      customFilters,
    });
  };
};
export const changeFaktura = (faktura) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_FAKTURA,
      data: faktura,
    });
  };
};

const getFakturaRequest = () => ({
  type: actionTypes.GET_FAKTURA_REQUEST,
});
const getFakturaSuccess = (res) => ({
  type: actionTypes.GET_FAKTURA_SUCCESS,
  res,
});
const getFakturaFailure = (error) => ({
  type: actionTypes.GET_FAKTURA_FAILURE,
  error,
});
export const getFaktura = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getFakturaRequest());
      let res = await fakturyUtils.getFaktura(id);
      dispatch(getFakturaSuccess(res));
    } catch (error) {
      dispatch(getFakturaFailure(error));
    }
  };
};

const getFakturaPDFRequest = () => ({
  type: actionTypes.GET_FAKTURA_PDF_REQUEST,
});
const getFakturaPDFSuccess = (res) => ({
  type: actionTypes.GET_FAKTURA_PDF_SUCCESS,
  res,
});
const getFakturaPDFFailure = (error) => ({
  type: actionTypes.GET_FAKTURA_PDF_FAILURE,
  error,
});
export const getFakturaPDF = (id, fileName) => {
  return async (dispatch) => {
    try {
      dispatch(getFakturaPDFRequest());
      let res = await fakturyUtils.getFakturaPDF(id, fileName);
      dispatch(getFakturaPDFSuccess(res));
    } catch (error) {
      dispatch(getFakturaPDFFailure(error));
    }
  };
};

const getListFakturaRequest = () => ({
  type: actionTypes.GET_LIST_FAKTURA_REQUEST,
});
const getListFakturaSuccess = (
  res,
  gridFilter,
  gridSort,
  gridPage,
  customFilters
) => ({
  type: actionTypes.GET_LIST_FAKTURA_SUCCESS,
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
  res,
});
const getListFakturaFailure = (error) => ({
  type: actionTypes.GET_LIST_FAKTURA_FAILURE,
  error,
});
export const getListFaktura = ({
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      dispatch(getListFakturaRequest());

      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await fakturyUtils.getListFaktura(filter, gridSort, gridPage);

      dispatch(
        getListFakturaSuccess(
          res,
          gridFilter,
          gridSort,
          gridPage,
          customFilters
        )
      );
    } catch (error) {
      dispatch(getListFakturaFailure(error));
    }
  };
};
